import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import Hero from './sections/Hero';
import Question from './sections/Question';
import FeelingSection from './sections/FeelingSection';
import MemoryWall from './sections/MemoryWall';
import FinalMessage from './sections/FinalMessage';
import Footer from './sections/Footer';

function App() {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    // Smooth scroll with requestAnimationFrame
    let scrolling = false;

    const smoothScroll = () => {
      if (scrolling) {
        window.requestAnimationFrame(smoothScroll);
      }
    };

    const handleScroll = () => {
      if (!scrolling) {
        scrolling = true;
        smoothScroll();
      }
      scrolling = false;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleAccept = () => {
    setAccepted(true);
  };

  const feelings = [
    {
      emoji: '🌟',
      title: 'Inspired',
      description: 'You inspire me to be the best version of myself every single day',
      color: '#FFD0D8'
    },
    {
      emoji: '☀️',
      title: 'Energized',
      description: 'Your smile brightens my darkest days and fills me with endless energy',
      color: '#FFB6C8'
    },
    {
      emoji: '🦋',
      title: 'Free',
      description: 'With you, I can truly be myself without any fears or pretense',
      color: '#FFC0CB'
    },
    {
      emoji: '🌸',
      title: 'Grateful',
      description: 'Every moment with you is a gift I cherish more than words can express',
      color: '#FFCAD4'
    },
    {
      emoji: '💫',
      title: 'Complete',
      description: 'You fill the spaces in my heart I didn\'t know were empty',
      color: '#FFD5DC'
    },
    {
      emoji: '💖',
      title: 'Loved',
      description: 'Your love makes me feel like the luckiest person alive',
      color: '#FFE0E6'
    }
  ];

  return (
    <div className="App">
      <Hero />
      <Question onAccept={handleAccept} />
      
      {accepted && (
        <>
          {feelings.map((feeling, index) => (
            <FeelingSection 
              key={index}
              {...feeling}
              index={index}
            />
          ))}
          <MemoryWall />
          <FinalMessage />
        </>
      )}
      <Footer/>
    </div>
  );
}

export default App;